// Global 'window.wrike' is for sharing function between pages.
//
// If you want your function to be available on any page,
// add it to the window.wrike window.wrike object.
/**
 * Boolean flag about page.
 * Isn't a function! Don't try run it!
 */
window.wrike.isLanding = (function() {
    var landingLocales = ['nl', 'pl', 'zh-cn', 'zh-tw', 'sv', 'ko', 'da', 'no', 'ms', 'id'];

    return landingLocales.some(function(locale) {
        return window.wrike.locale === locale;
    });
})();

/**
 * Get locale chunk for construct URL
 *
 * @return {string} - locale URL chunk
 * @example
 * // '/' for en locale
 * getPathLocale()
 * @example
 * // '/de' for de locale
 * getPathLocale()
 */
window.wrike.getPathLocale = function() {
    return window.wrike.locale === 'en' ? '' : '/' + window.wrike.locale;
};

/**
 * Get date of next month
 *
 * @return {string} - date of day
 * @example
 * // "Mon, 31 Oct 2016 19:03:46 GMT"
 * getDatePlus31("Thu, 29 Sep 2016 19:03:46 GMT");
 */
window.wrike.getDatePlus31 = function() {
    var datePlus31 = new Date();

    /* eslint-disable no-magic-numbers */

    datePlus31.setTime(datePlus31.getTime() + 31 * 24 * 60 * 60 * 1000);

    /* eslint-enable no-magic-numbers */

    datePlus31 = datePlus31.toGMTString();
    return datePlus31;
};

/**
 * Returns whether the user logged in before
 */
window.wrike.isWasLoggedInWS = (function() {
    return WG.utils.getCookie('uid');
})();

/**
 * Get the status of the user currently logged
 *
 * @return {boolean} - status
 */
window.wrike.isLoggedInWS = function() {
    return WG.utils.getCookie('uid');
};

/**
 * Return random integer value from start to end
 *
 * @param {number} start minimal number of random
 * @param {number} end maximal number of random
 * @return {number} random integer number
 */
window.wrike.getRandomInt = function(start, end) {
    end = end || start;
    return Math.floor(Math.random() * (end - start + 1)) + start;
};

/**
 * Return winner url by uses percent
 *
 * @param {array} data array with object url and percent
 * example: dataPages[{object: /mypage/, percent: 50}, {object: /mypage2/, percent: 50},]
 * @param {string} data.object in object - URL page
 * @param {number} data.percent in object - Percentage of traffic
 * @return {string} Winner page
 */
window.wrike.getWinnerObject = function(data) {
    var startRandomRange = 0;
    var endRandomRange = 99;
    var randomNumber = this.getRandomInt(startRandomRange, endRandomRange);
    var endStep = 0;
    var winObject = '';

    data.forEach(function(item) {
        if (randomNumber >= endStep && randomNumber < item.percent + endStep) {
            winObject = item.object;
        }

        endStep += item.percent;
    });

    return winObject;
};

/**
 * Get search string parameter value.
 *
 * @param {string} name - Name of the search string parameter.
 * @return {string} - value of parameter
 */
window.wrike.getGETParameterByName = function(name) {
    var param = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + param + '=([^&#]*)');
    var results = regex.exec(location.search);

    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

/**
 * Disable the form.
 *
 * @param {jQuery} $form - Form jQuery object
 * @return {void}
 */
window.wrike.disableForm = function($form) {
    $form.attr('submitting', true);
    $form.find('.wg-input, .wg-select').attr('disabled', 'disabled');
    $form
        .find('.wg-btn')
        .wgInstance()
        .loading();
};

/**
 * Reset the form.
 *
 * @param {jQuery} $form - Form jQuery object
 * @return {void}
 */
window.wrike.resetForm = function($form) {
    const $inputs = $form.find('.wg-textfield__input');
    const $select = $form.find('.wg-textfield__select');
    const inputClassFilled = 'wg-textfield__input--filled';
    const selectClassFilled = 'wg-textfield__select--filled';

    $form.trigger('reset');
    $inputs.removeClass(inputClassFilled);
    $select.removeClass(selectClassFilled);
    window.wrike.enableForm($form);
};

/**
 * Enable the form.
 *
 * @param {jQuery} $form - Form jQuery object
 * @return {void}
 */
window.wrike.enableForm = function($form) {
    $form.find('.wg-input, .wg-select').removeAttr('disabled');
    $form
        .find('.wg-btn')
        .wgInstance()
        .reset();
    $form.removeAttr('submitting');
};

/**
 * @param {string} url - URL
 * @return {string} - inputs string
 * */
window.wrike.convertURL2Inputs = function(url) {
    /* eslint-disable vars-on-top, newline-after-var */
    var link = document.createElement('a');
    link.href = url;
    var urlSearch = link.search.substr(1);
    var params = urlSearch.split('&');
    var inputs = '';

    $(params).each(function(index, line) {
        line = line.split('=');
        inputs +=
            '<input type="hidden" name="' +
            decodeURIComponent(line[0]) +
            '" value="' +
            decodeURIComponent(line[1]) +
            '">';
    });

    return inputs;
};
/* eslint-enable vars-on-top, newline-after-var */

/**
 * @param {array<object>} data — array of objects
 * @return {object} - pairs object
 * @example
 * // {"name":"example name","email":"example@example.example","code":"+1","phone":"(654) 354-3543"}
 * [{"name":"name","value":"example name"},{"name":"email","value":"example@example.example"},{"name":"code","value":"+1"},{"name":"phone","value":"(654) 354-3543"}]
 * */
window.wrike.fromPairs = function(data) {
    return data.reduce(function(collect, element) {
        collect[element['name']] = element.value;
        return collect;
    }, {});
};

/**
 * @param {string} group - Group name
 * @param {string} event - Event name
 * @param {object} value - Options object
 * @param {boolean} enqueue - Enqueue
 * @return {Promise}
 * */
window.wrike.trackButtonEvent = function(group, event, value, enqueue = true) {
    var trackingOptions = {
        group: group,
        event: event
    };

    if (typeof value !== 'undefined' && value) {
        trackingOptions['value'] = value;
    }

    var tracking = new WG.Tracking(trackingOptions);

    return tracking.send(enqueue);
};

/**
 * @param {string} event - Event name
 * @param {string} params - Parameters object
 * @return {void}
 * */
window.wrike.trackCustomEvent = function(event, params) {
    return WG.utils.trackCustomEvent(event, params);
};

/**
 * Shake!
 * @param {jQuery} $target - Element for shaking
 * @param {number} timeout - Element for shaking
 * @return {void}
 * */
window.wrike.shake = function($target, timeout) {
    $target.addClass('validation-shaking');
    setTimeout(function() {
        $target.removeClass('validation-shaking');
    }, timeout);
};

/**
 * trackEventForm
 * @param {object} options - Options
 * @param {boolean} enqueue - Enqueue
 * @return {Promise}
 * */
window.wrike.trackEventForm = function(options, enqueue = true) {
    var tracking = new WG.Tracking(options);
    return tracking.send(enqueue);
};

/* eslint-disable */
window.wrike.openCenterWindow = function openCenterWindow(url, title, w, h) {
    var dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : screen.left;
    var dualScreenTop = window.screenTop !== undefined ? window.screenTop : screen.top;

    var width = window.innerWidth
        ? window.innerWidth
        : document.documentElement.clientWidth
            ? document.documentElement.clientWidth
            : screen.width;
    var height = window.innerHeight
        ? window.innerHeight
        : document.documentElement.clientHeight
            ? document.documentElement.clientHeight
            : screen.height;

    var left = width / 2 - w / 2 + dualScreenLeft;
    var top = height / 2 - h / 2 + dualScreenTop;
    var newWindow = window.open(
        url,
        title,
        'scrollbars=yes, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left
    );

    if (window.focus) {
        newWindow.focus();
    }
};

window.wrike.expireYear = function() {
    const expires = new Date();

    expires.setDate(expires.getDate() + 365);
    return expires.toGMTString();
};



// WEBPACK FOOTER //
// ./assets/js/common/modules/global.js